// Is a cover / header color light enough that white text on it is hard to
// read? Accepts "#rrggbb", "#a,#b" (gradient), a CSS background string
// containing hex colors, or a preset name (resolved by the caller).
function luminance(hex) {
  let h = String(hex).replace('#', '');
  if (h.length === 3) h = h.split('').map((c) => c + c).join('');
  const n = parseInt(h.slice(0, 6), 16);
  if (Number.isNaN(n)) return 0;
  const lin = (v) => { v /= 255; return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4; };
  return 0.2126 * lin((n >> 16) & 255) + 0.7152 * lin((n >> 8) & 255) + 0.0722 * lin(n & 255);
}

export function isLightColor(value) {
  if (!value || typeof value !== 'string') return false;
  const hexes = value.match(/#[0-9a-fA-F]{3,8}\b/g) || [];
  if (!hexes.length) return false;
  const avg = hexes.reduce((s, c) => s + luminance(c), 0) / hexes.length;
  return avg > 0.4;
}

/** Text colors for content placed on {@code value}. */
export function textOn(value) {
  return isLightColor(value)
    ? { color: '#111827', sub: '#374151', shadow: 'none' }
    : { color: '#ffffff', sub: '#ffffff', shadow: '0 1px 6px rgba(0,0,0,0.35)' };
}
